import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { postData } from "../../services/generalService";
import { PaymentReversalPostResponsenObj } from "../../utils/types";

const initialState: PaymentReversalPostResponsenObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const postPaymentReversalTransaction = createAsyncThunk(
  "loans/postPaymentReversalTransaction",
  async (formData: { url: string; postsData: {} }, thunkAPI) => {
    const { url, postsData } = formData;
    try {
      const data = await postData(url, postsData, true);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const postPaymentReversalTransactionSlice = createSlice({
  name: "postPaymentReversalTransaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postPaymentReversalTransaction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postPaymentReversalTransaction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(postPaymentReversalTransaction.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default postPaymentReversalTransactionSlice.reducer;
